
/*
 * Project: LegalPlace assistant
 * File: src/app/ops/contacts.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/


const HUB_TOKEN = '86e28b6a-78e9-427f-8127-ce32b89b3397';

// operations routes.
const H_GET_PROFILE_BY_MAIL = 'https://api.hubapi.com/contacts/v1/contact/email/'; // + mail + /profile?hapikey= ......
const H_ADD_CONTACT = 'https://api.hubapi.com/contacts/v1/contact/'; // + ?hapikey=....


class LpContactsOps {
  constructor() {
    this.name = '';
    this.mail = '';
    this.phone_number = '';
    this.address = '';
  }

  registerMail(mail) {
    this.mail = mail;
  }

  /**
   *
   * @param {string} mail
   */
  static async checkContactExistance(mail) {
    if (mail === '') return false;
    const a = await fetch(`${H_GET_PROFILE_BY_MAIL + mail}/profile?hapikey=${HUB_TOKEN}`);
    const json = await a.json();
    if (json.status === 'error') return false;
    return json;
  }

  async saveHubSpot() {
    // if(!this.__checkBasics())
    //     return;
    // TODO: this can be changable.

    const data = {
      properties: [
        {
          property: 'email',
          value: this.mail,
        },
        {
          property: 'firstname',
          value: this.name,
        },
        {
          property: 'phone',
          value: this.phone_number,
        },
        {
          property: 'website',
          value: window.location.href,
        },
        {
          property: 'address',
          value: this.address,
        },
            ]
        };
        if(!(await this.checkContactExistance(this.mail)))
        fetch(H_ADD_CONTACT + "?hapikey=86e28b6a-78e9-427f-8127-ce32b89b3397", {
            method: 'POST',
            body: JSON.stringify(data)
        }).then(resp => {
            if(resp.status === 200)
                console.log("contact saved");
        }).catch(err => {
            console.log(err);
        });
    }
}


export default LpContactsOps;



// WEBPACK FOOTER //
// ./src/app/ops/contacts.js